module.exports = __webpack_public_path__ + "img/IMG_1340.adbb61a6.png";